import { render, staticRenderFns } from "./ReportTabOpportunities.vue?vue&type=template&id=915e966c&scoped=true"
import script from "./ReportTabOpportunities.vue?vue&type=script&lang=js"
export * from "./ReportTabOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915e966c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915e966c')) {
      api.createRecord('915e966c', component.options)
    } else {
      api.reload('915e966c', component.options)
    }
    module.hot.accept("./ReportTabOpportunities.vue?vue&type=template&id=915e966c&scoped=true", function () {
      api.rerender('915e966c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Report/Tab/ReportTabOpportunities.vue"
export default component.exports